// This file was generated by the Zuplo CLI migrate-dev-portal command.
// It is used to configure the Zuplo dev portal.
// You can edit this file to customize the dev portal.
// For more information, see https://zuplo.com/docs/dev-portal/zudoku/configuration/overview
import type { ZudokuConfig } from "zudoku";

const config: ZudokuConfig = {
  site: {
    title: "Centinus Developer API",
    logo: {
      src: {
        light: "/Centinus-logo-horizontal.png",
        dark: "/Centinus-logo-horizontal.png",
      },
      alt: "Centinus Developer API",
      href: "/",
      width: 200,
    },
  },
  metadata: {
    title: "Centinus Developer API",
  },
  navigation: [
    // {
    //   type: "doc",
    //   file: "index",
    //   label: "Index",
    // },
    {
      type: "link",
      to: "/api",
      label: "API Reference",
    },
  ],
    redirects: [{ from: "/", to: "/api" }],
  apis: [
    {
      type: "file",
      input: "../config/routes.oas.json",
      path: "/api",
    },
  ],
  authentication: {
    type: "auth0",
    clientId: "skeBCzm1Fb9JBCqpGmPkf2YxPVaM3wVG",
    domain: "centinus.us.auth0.com",
    audience: "https://auth.centinus.com/",
  },
};
export default config;
